export default {
  data() {
    return {
      routeData: {
        home: [],
        about: [
          {
            name: '公司简介',
            moduleName: 'jianjie'
          },
          {
            name: '公司荣誉',
            moduleName: 'honor'
          },
          {
            name: '企业文化',
            moduleName: 'corporateCulture'
          },
          {
            name: '体系认证',
            moduleName: 'txrz'
          }
        ],
        productCenter: [
          {
            name: '产品分类',
            moduleName: 'productSort'
          },
          {
            name: '生产装备',
            moduleName: 'sczb'
          }
        ],
        rdCenter: [
          {
            name: '实验设备',
            moduleName: 'sysb'
          },
          /*{
            name: '研发团队',
            moduleName: 'yftd'
          },*/
          {
            name: '发展历程',
            moduleName: 'fzlc'
          },
          {
            name: '所获专利',
            moduleName: 'shzl'
          },
        ],
        newsList: [
          {
            name: '公司新闻',
            moduleName: 'gsxw'
          },
          {
            name: '全部动态',
            moduleName: 'qbdt'
          }
        ],
        contactUs: [
          {
            name: '联系我们',
            moduleName: 'lxwm'
          },
          {
            name: '留言反馈',
            moduleName: 'lyfk'
          }
        ],
        jiejue: []
      },
      nameShow: {
        about: '关于汇东',
        productCenter: '产品中心',
        rdCenter: '研发中心',
        newsList: '新闻资讯',
        contactUs: '联系我们'
      }
    };
  },
  methods: {
    scrollToElementWithOffset(item) {
      const element = document.getElementById(item.moduleName);
      if (element) {
        // 获取目标元素相对于整个文档的位置
        const rect = element.getBoundingClientRect();
        // 滚动到目标元素位置，并加上偏移量
        window.scrollTo({
          top: rect.top + window.scrollY - 90,
          behavior: 'smooth'
        });
      }
    }
  }
};
